import React from "react";
import { Box, Button, Chip } from "@mui/material";
import {
  TRIVIA_RESULTS_SAFE_PADDING_BOTTOM,
  arcadeFilledButtonSx,
} from "../../utils/triviaResultsLayout";

const PRIMARY_SX = {
  ...arcadeFilledButtonSx,
  minWidth: 220,
  px: 3,
};

const TriviaResultsActions = ({
  isDaily,
  onPlayAgain,
  onBack,
  onViewLeaderboard,
}) => {
  const primary = isDaily
    ? { label: "View leaderboard", onClick: onViewLeaderboard }
    : { label: "Play Again", onClick: onPlayAgain };

  return (
    <Box
      component="nav"
      aria-label="Results actions"
      data-testid="trivia-results-actions"
      data-safe-area="bottom"
      sx={{
        mt: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        pb: TRIVIA_RESULTS_SAFE_PADDING_BOTTOM,
      }}
    >
      {isDaily ? (
        <Chip
          label="Come back tomorrow"
          size="small"
          variant="outlined"
          sx={{
            color: "text.secondary",
            borderColor: "rgba(255,255,255,0.16)",
          }}
        />
      ) : null}

      <Button variant="contained" onClick={primary.onClick} sx={PRIMARY_SX}>
        {primary.label}
      </Button>

      <Button
        variant="text"
        onClick={onBack}
        sx={{
          color: "text.secondary",
          minHeight: 44,
          px: 2,
          "&:hover": { bgcolor: "rgba(255,255,255,0.06)" },
        }}
      >
        Back to hub
      </Button>
    </Box>
  );
};

export default TriviaResultsActions;
